<template>
    <main class="container_applicationweb_mobile" id="ApplicationWebMobile">
        <!--section top -->
        <section class="container_applicationweb_mobile__section_top">
            <!-- article top -->
            <article class="container_applicationweb_mobile__section_top__article_top">
                <aside class="container_applicationweb_mobile__section_top__article_top__aside">
                    <div class="container_applicationweb_mobile__section_top__article_top__aside__div">
                        <h1 class="container_applicationweb_mobile__section_top__article_top__aside__div__h1">
                            Application web
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_applicationweb_mobile__section_top__article_bottom">
                <aside class="container_applicationweb_mobile__section_top__article_bottom__aside">
                    <div class="container_applicationweb_mobile__section_top__article_bottom__aside__div_top">
                        <img src="@/assets/shopping.jpg" alt="Application web"
                            class="container_applicationweb_mobile__section_top__article_bottom__aside__div_top__img">
                    </div>
                    <!-- div bottom -->
                    <div class="container_applicationweb_mobile__section_top__article_bottom__aside__div_bottom">
                        <p class="container_applicationweb_mobile__section_top__article_bottom__aside__div_bottom__p">
                            une application web est une application manipulable directement en ligne grâce à un
                            navigateur web et qui ne nécessite donc pas d'installation sur les machines clientes,
                            contrairement aux applications mobiles.
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
            </article>
            <!-- hidden -->
            <article class="w3-container container_applicationweb_mobile__section_top__article_hidden">
                <aside id="id01" class="w3-modal container_applicationweb_mobile__section_top__article_hidden__aside">
                    <!-- div options -->
                    <div
                        class="w3-modal-content container_applicationweb_mobile__section_top__article_hidden__aside__div">
                        <div
                            class="w3-container container_applicationweb_mobile__section_top__article_hidden__aside__div__div btn cancel">
                            <span onclick="closeForm()" class="w3-button w3-display-topright">&times;</span>
                            <h1
                                class="container_applicationweb_mobile__section_top__article_hidden__aside__div__div__h1">
                                Options
                            </h1>
                            <p class="container_applicationweb_mobile__section_top__article_hidden__aside__div__div__p">
                                - 300€ maquette sans animation ( adobe XD )<br />
                                - 600€ maquette avec animations ( 2 modifications gratuites )<br />
                                - 200€ la modifications et 100€ par jours de retard ( du client au sujet de la
                                modifications maquette )<br />
                                - 200€ l'hébergement web<br />
                                - 2 000€ déplacement ( en France )( voir CGV pour plus d'information )<br />
                                - Maintenance 280€ l'ajout<br />
                                - Devis 100€<br />
                            </p>
                        </div>
                    </div>
                </aside>
            </article>
        </section>
        <!-- section bottom-->
        <section class="container_applicationweb_mobile__section_bottom">
            <article class="container_applicationweb_mobile__section_bottom__article_top">
                <aside class="container_applicationweb_mobile__section_bottom__article_top__aside_top">
                    <div class="container_applicationweb_mobile__section_bottom__article_top__aside_top__div_title">
                        <h1
                            class="container_applicationweb_mobile__section_bottom__article_top__aside_top__div_title__h1">
                            Tarif
                        </h1>
                    </div>
                    <!-- div -->
                    <div class="container_applicationweb_mobile__section_bottom__article_top__aside_top__div_text">
                        <p class="container_applicationweb_mobile__section_bottom__article_top__aside_top__div_text__p">
                            - Maquette Adobe XD <br>
                            - 5 Modifications gratuites <br>
                            - Gestion de bases données <br>
                        </p>
                        <p
                            class="container_applicationweb_mobile__section_bottom__article_top__aside_top__div_text__prix">
                            Prix total : 6 100 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_applicationweb_mobile__section_bottom__article_top__aside_bottom">
                    <div class="container_applicationweb_mobile__section_bottom__article_top__aside_bottom__div_left">
                        <router-link
                            class="container_applicationweb_mobile__section_bottom__article_top__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_applicationweb_mobile__section_bottom__article_top__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                    <div
                        class="container_applicationweb_mobile__section_bottom__article_top__aside_bottom__div_right open-button">
                        <button onclick="openForm()"
                            class="container_applicationweb_mobile__section_bottom__article_top__aside_bottom__div_right__button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-plus-circle-fill container_applicationweb_mobile__section_bottom__article_top__aside_bottom__div_right__button__svg"
                                viewBox="0 0 16 16">
                                <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                            </svg>
                        </button>
                    </div>
                </aside>
            </article>
            <!-- article bottom-->
            <article class="container_applicationweb_mobile__section_bottom__article_bottom">
                <aside class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left">
                    <router-link
                        class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link"
                        to="/site-vitrine">
                        <button
                            class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button">
                            <div class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back"
                                id="div_button">
                                <img src="@/assets/back.png" alt="back"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back__img"
                                    id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
                <!-- aside right -->
                <aside class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right">
                    <router-link
                        class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link"
                        to="/wordpress">
                        <button
                            class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button">
                            <div class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next"
                                id="div_button">
                                <img src="@/assets/next.png" alt="next"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next__img"
                                    id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'ApplicationWebMobile',
}

</script>

<style  lang=scss>
router-link {
    display: block;
}

@import "@/style/components/Services/Application-web/ApplicationWebMobile.scss";

@media screen and(min-width: 926px) {
    #ApplicationWebMobile {
        display: none;
    }
}
</style>